module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Icon-Braun.ecdddcfc.svg";